import { render, staticRenderFns } from "./videoByLink.vue?vue&type=template&id=6912e6a8&scoped=true"
import script from "./videoByLink.vue?vue&type=script&lang=js"
export * from "./videoByLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912e6a8",
  null
  
)

export default component.exports